var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18402_3042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80384 10.671L4.15416 12.3207C3.47023 13.0046 2.36266 13.0046 1.67931 12.3209C0.995824 11.6374 0.995824 10.5297 1.67918 9.84634L4.97912 6.54639C5.66247 5.86301 6.77015 5.86301 7.4535 6.54639C7.6813 6.77419 8.05066 6.77419 8.27847 6.54639C8.50627 6.31859 8.50627 5.94923 8.27847 5.72142C7.13948 4.58244 5.29314 4.58244 4.15416 5.72142L0.854237 9.02134C-0.284746 10.1603 -0.284746 12.0067 0.854237 13.1457C1.99308 14.2852 3.83956 14.2852 4.97915 13.1457L6.62883 11.496C6.85664 11.2682 6.85664 10.8988 6.62883 10.671C6.40103 10.4432 6.03164 10.4432 5.80384 10.671Z",
    fill: "#434852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1454 0.854237C12.0064 -0.284746 10.1595 -0.284746 9.02047 0.854237L7.04121 2.8335C6.81341 3.0613 6.81341 3.43066 7.04121 3.65846C7.26902 3.88627 7.63838 3.88627 7.86618 3.65846L9.84544 1.6792C10.5288 0.995824 11.637 0.995824 12.3204 1.6792C13.0038 2.36255 13.0038 3.47023 12.3204 4.15358L8.6909 7.78313C8.00752 8.46651 6.89987 8.46651 6.21652 7.78313C5.98872 7.55533 5.61936 7.55533 5.39155 7.78313C5.16375 8.01093 5.16375 8.38029 5.39155 8.60809C6.53054 9.74708 8.37688 9.74708 9.51586 8.60809L13.1454 4.97857C14.2844 3.83959 14.2844 1.99322 13.1454 0.854237Z",
    fill: "#434852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18402_3042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskLinkIcon);
export default __webpack_public_path__ + "static/media/taskLinkIcon.d5fc362509f7ea4fec48e93107002272.svg";
export { ForwardRef as ReactComponent };